import httpService from './httpService';
import { buildApiUrl } from '@ss/helpers/buildApiUrl';
const get = async () => {
    const apiUrl = buildApiUrl('/tags');
    return httpService.request('get', apiUrl);
};
export default {
    get,
};
